var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-box"},[_c('p',{staticClass:"code-tips",style:(_vm.qrText),domProps:{"innerHTML":_vm._s(_vm.letter.qrCodeTip)}}),_c('img',{staticClass:"code",attrs:{"src":_vm.qrcodeSrc},on:{"click":_vm.updateCodeState}})])}
var staticRenderFns = []

export { render, staticRenderFns }